<template>
  <div class="content">
    <iframe id='code_iframe' src="code.html" frameborder="0" scrolling="no" @load="load" style="width: 100%"/>
  </div>
</template>

<script>

export default {
  name: 'Code',
  methods:{
    load: function(){
      var obj = document.getElementById("code_iframe")
      obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px'
    }
  },
  mounted: function(){
    
  },
  components:{
    
  }
}
</script>

<style scoped>

</style>
